import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import appSettings from 'wanderu-config';

import styles from './Modal.scss';

function Modal(props) {
    if (!appSettings.env.isClient) return null;
    return ReactDOM.createPortal(
        <div className={classNames(props.className, styles.modal)}>
            {props.children}
        </div>,
        document.body,
    );
}

Modal.propTypes = {
    className: PropTypes.string,
};

Modal.defaultProps = {
    className: '',
};

export default Modal;
